// extracted by mini-css-extract-plugin
export default {"grid":"storyboardList_grid__+Tesy"};